import React, { useState, useEffect } from 'react';
import { useSteps } from '../../contexts/stepContext';
import { BarProgress, BarProgressDone, ProgressCount } from './styles';

const ProgressBar: React.FC = () => {
  const { progress } = useSteps();
  const [style, setStyle] = useState({});

  useEffect(() => {
    const newStyle = {
      opacity: 1,
      width: `${progress}%`,
    };

    setStyle(newStyle);
  }, [progress]);

  return (
    <BarProgress>
      <ProgressCount>{progress}%</ProgressCount>
      <BarProgressDone style={style} />
    </BarProgress>
  );
};

export default ProgressBar;
